
(function () {
  const frameImages = {
    'stretched canvas':
      'https://cdn.shopify.com/s/files/1/0943/2573/5792/files/stretched-canvas_jpg.jpg?v=1792561891',

    'golden floater frame':
      'https://cdn.shopify.com/s/files/1/0943/2573/5792/files/golden-frame_jpg.jpg?v=1792561891',

    'black floater frame':
      'https://cdn.shopify.com/s/files/1/0943/2573/5792/files/black-frame_jpg.jpg?v=1792561891',

    'without frame':
      'https://cdn.shopify.com/s/files/1/0943/2573/5792/files/without-frame_jpg.jpg?v=1792561890'
  };

  function normalize(text) {
    return (text || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function findFrame(value) {
    const text = normalize(value);

    if (text.includes('black')) return 'black floater frame';
    if (text.includes('golden') || text.includes('gold'))
      return 'golden floater frame';
    if (text.includes('stretched')) return 'stretched canvas';
    if (text.includes('without') || text.includes('rolled'))
      return 'without frame';

    return null;
  }

  function activateGalleryImage(productInfo, frame) {
    const url = frameImages[frame];
    if (!url) return;

    const gallery = productInfo.querySelector('media-gallery');
    if (!gallery) return;

    const images = gallery.querySelectorAll(
      '.product__media img, .thumbnail img'
    );

    let matchingMediaId = null;

    images.forEach((img) => {
      const src = img.currentSrc || img.src || img.dataset.src || '';
      if (src && src.split('?')[0] === url.split('?')[0]) {
        const media = img.closest('[data-media-id]');
        if (media) matchingMediaId = media.dataset.mediaId;
      }
    });

    if (matchingMediaId) {
      gallery.setActiveMedia(matchingMediaId, true);
    }
  }

  function init() {
    document.querySelectorAll('product-info').forEach((productInfo) => {
      if (productInfo.dataset.frameSwitcherReady) return;
      productInfo.dataset.frameSwitcherReady = 'true';

      productInfo.addEventListener('change', (event) => {
        const input = event.target;
        if (!input.matches('input[type="radio"], select')) return;

        const optionName = normalize(input.name);
        const optionLabel = normalize(
          input.closest('fieldset')?.querySelector('legend')?.textContent ||
          input.closest('.product-form__input')?.querySelector('label')?.textContent
        );

        if (
          !optionName.includes('frame') &&
          !optionLabel.includes('frame')
        ) return;

        const frame = findFrame(input.value);
        if (frame) activateGalleryImage(productInfo, frame);
      });

      const checkedFrame = productInfo.querySelector(
        'input[type="radio"]:checked'
      );

      if (checkedFrame) {
        const frame = findFrame(checkedFrame.value);
        if (frame) activateGalleryImage(productInfo, frame);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
